import Rellax from 'rellax';

export function init() {
    if (window.matchMedia("(max-width: 768px)").matches) return;

    const rellaxEls = document.querySelectorAll('.js-rellax');
    if (!rellaxEls || rellaxEls.length == 0) return;
    
    this.rellax = new Rellax('.js-rellax');
}

export function update() {
    if (!this.rellax) return;
    this.rellax.refresh();
}